<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap">
        <a-form-model
          layout="inline"
        :model="searchForm.data">
          <a-form-model-item :label="$t('TITLE')||'标题'">
            <a-input v-model="searchForm.data.title" allowClear/>
          </a-form-model-item>
          <a-form-model-item>
            <a-button
        type="primary"
        plain
        icon="el-icon-search"
                      @click="getNewsList">{{ $t('SEARCH') || '查询' }}
            </a-button>
          </a-form-model-item>
        </a-form-model>
        <div>
          <a-button type="primary" @click="addNews">
            {{ $t('ADD') || '添加' }}
          </a-button>
        </div>
      </div>

      <a-table
        :data-source="table.data"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        row-key="id"
        style="width: 100%">
        <a-table-column
          data-index="articleType"
          title="咨询类型"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="title"
          :title="$t('TITLE')||'标题'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="subTitle"
          :title="$t('SUB_TITLE')||'副标题'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="postAt"
          :title="$t('POST_AT')||'发表时间'"
          width="180">
          <template slot-scope="text,record">
            <time-formatter :time="record.postAt" format="YYYY-MM-DD HH:mm:ss"/>
          </template>
        </a-table-column>
        <a-table-column
          data-index="coverPath"
          :title="$t('Cover image')||'封面图片'"
          width="180">
          <template slot-scope="text,record">
            <img
              style="width: 50px; height: auto"
              :src="record.coverPath"
              :preview-src-list="[record.coverPath]"/>
          </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION')||'操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="editNews(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button type="link" @click="deleteNews(record.id)">{{ $t('DELETE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
:footer="null"
             :title="$t('BRAND_NEWS_EDIT')||'操作'"
             width="50%"
             mask-closeable="false"
             v-model="form.visible">
      <news-edit
        v-if="form.visible"
        :news-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </news-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryGoodsBrands,
} from '@/api/goodsBrandApi';
import {
  _queryNewss,
  _deleteNews,
} from '@/api/newsApi';
import NewsEdit from './NewsEdit.vue';
import TimeFormatter from '../../../components/TimeFormatter.vue';

async function getNewsList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryNewss({
    brandId: this.searchForm.data.brandId,
    title: this.searchForm.data.title,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
}

function addNews() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editNews(newsId) {
  this.$router.push(`/news/${newsId}`);
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getNewsList();
}

async function deleteNews(newsId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      await _deleteNews(newsId);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.getNewsList();
    },
  });
}

export default {
  name: 'NewsList',
  components: {
    TimeFormatter,
    NewsEdit,
  },
  data() {
    return {
      brand: {
        data: [],
      },
      searchForm: {
        data: {
          brandId: '',
          title: '',
        },
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'postAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getNewsList,
    deleteNews,
    editNews,
    addNews,
    closeForm,
  },
  async created() {
    const brandResult = await _queryGoodsBrands({});
    this.brand.data = brandResult.content;
    await this.getNewsList();
  },
};
</script>

<style scoped>

</style>
